<template>
    <div :class="menu ? 'menu-active' : ''">
        <header id="header" class="oswald">
            <div id="preheader" class="sitecolor-content">
                <div class="container">
                    <div class="row align-items-center justify-content-between">
                        <div class="col-12 d-flex align-items-center">
                            
                            <div class="hamburger d-lg-none hamburger--spring js-hamburger" @click="showMenu()">
                                <div class="hamburger-box">
                                    <div class="hamburger-inner"></div>
                                </div>
                            </div>
                            <div class="col-6 col-md-6 d-none d-lg-flex" style="text-transform: uppercase">
                                {{ $t('header.venta_entradas', { entradas: footer.termino_entradas }) }}
                            </div>
                            <div class="col-6 col-md-6 text-right d-none d-lg-block">
                                <a href="https://www.compralaentrada.com" target="_blank"><img src="https://apiteatros.compralaentrada.com/images/logo_compralaentrada_white.png" width="180"/></a>
                            </div>
                            <router-link
                                :to="{ name: 'front.home' }"
                                class="logo d-lg-none router-link-active"
                                :style='"background-image: url(" + footer.logo + ")"'
                            >
                                <div class="h4 m-0">
                                    <template v-if="footer.tipo == 1">
                                        {{ configuracion.title }}
                                    </template>
                                </div>
                            </router-link>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="teatro.carrito_varios_eventos" style="color: black;" class="carrito d-lg-none ">
                <CarritoOnline v-if="isMobile" button_color="white" />
            </div>
            <div class="container-navbar">
                <div class="navbar-wrapper">
                    
                    <div class="navbar-escudo">
                        <router-link
                            :to="{ name: 'front.home' }"
                            class="logo router-link-active"
                            :style='"background-image: url(" + footer.logo + ")"'
                            @click="menu = false"
                        >
                            <div class="h3 m-0" v-if="footer.tipo == 1">{{ configuracion.title }}</div>
                        </router-link>
                    </div>

                    <div class="navbar-menu">
                        <OptionsMenuComponent 
                            :footer="footer" 
                            :configuracion="configuracion" 
                            ul_class="d-flex m-0 justify-content-center"
                            @closeMenu="menu = false"
                        />
                    </div>

                    <div class="navbar-auth">
                        <OptionsAuthCartComponent 
                            :footer="footer" 
                            :configuracion="configuracion" 
                            ul_class="d-flex m-0 justify-content-end"
                            @closeMenu="menu = false"
                        />
                    </div>
                </div>
            </div>
        </header>
        <div id="aside">
            <div class="container">
                <div class="row align-items-end">
                    <div class="col-12">
                        <OptionsMenuMobileComponent 
                            btn_class="home-link d-flex text-center justify-content-center align-center align-items-center" 
                            :footer="footer"
                            :configuracion="configuracion"
                            @closeMenu="menu = false"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OptionsMenuComponent from './OptionsMenuComponent.vue';
    import OptionsAuthCartComponent from './OptionsAuthCartComponent.vue';
    import OptionsMenuMobileComponent from './OptionsMenuMobileComponent.vue';
    import CarritoOnline from '../carrito/CarritoOnline.vue';

    export default {
        data() {
            return {
                menu: false,
                isMobile : false
            }
        },
        created() {
            this.checkIfMobile()
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            url() {
                return this.$route.name;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
        },
        watch: {
            url() {
                this.menu = false;
            }
        },
        methods: {
            showMenu() {
                this.menu = !this.menu;
            },
            checkIfMobile() {
                this.isMobile = window.innerWidth < 1024;
            },
        },
        components: {
            OptionsMenuComponent, OptionsAuthCartComponent, OptionsMenuMobileComponent, CarritoOnline
        }
    }
</script>

<style scoped>
    .h3 {
        align-items: left;
    }

    .sitecolor-content {
        height: 2em;
        display: flex;
        justify-content: center;
        text-align: center;
    }
        
    .container-navbar {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .navbar-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }

    .navbar-escudo {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
    }

    .navbar-menu {
        flex: 1;
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .navbar-auth {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        padding-right: 20px;
    }

    #header .logo {
        background-size: auto 60px;
        min-height: 60px;
        padding-left: 100px;
        color: var(--sitecolor);
    }

    @media (max-width:  1024px) {
        .navbar-escudo {
            display: none;
        }
        .navbar-menu {
            display: none;
        }
        
        .navbar-auth {
            display: none;
        }

        #header .container {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .hamburger {
            order: 1;
        }

        .logo {
            order: 2;
        }

        .carrito {
            order: 3;
        }

        .hamburger, .logo {
            display: flex;
        }

        #header .logo {
            text-transform: uppercase;
            display: flex;
            background-repeat: no-repeat;
            background-size: contain; 
            min-height: 40px;
            background-position: left center;
            align-items: center;
            color: #ffffff; 
            padding-left: 45px;
        }
        
        .oswald {
            font-family: "Oswald", sans-serif !important;
        }

        .carrito {
            line-height: 1.3 !important;
            font-family: "Oswald", sans-serif !important;
            position: absolute !important;
            right: 2% !important;
            bottom: 15%;
            font-weight: 700;
            color: #555;
            font-size: 15px;
            text-transform: uppercase        }
    }
</style>